/**
 * DocumentiSection — F-006 Phase 5 (IMPL-P5-005).
 *
 * Grid of 4 DocumentoDownloadCard components, one per document type. Header
 * exposes a manual "Aggiorna" button so the user can re-check availability
 * without any auto-polling (per F-006 spec: ricevuta upload is a manual
 * operator workflow that can take hours/days).
 */
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PraticaDetailView } from '@app/shared';
import { DocumentoDownloadCard } from './DocumentoDownloadCard';

interface DocumentiSectionProps {
  pratica: PraticaDetailView;
  onRefresh: () => void;
  isRefreshing?: boolean;
}

export function DocumentiSection({ pratica, onRefresh, isRefreshing }: DocumentiSectionProps) {
  const { documenti, id } = pratica;
  return (
    <section className="space-y-4" aria-label="Documenti della pratica">
      <header className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Documenti</h2>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={isRefreshing}
          aria-label="Aggiorna disponibilità documenti"
        >
          <RefreshCw
            className={['mr-1 h-3.5 w-3.5', isRefreshing ? 'animate-spin' : ''].join(' ')}
            aria-hidden="true"
          />
          Aggiorna
        </Button>
      </header>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <DocumentoDownloadCard tipo="CONTRATTO_PDF" praticaId={id} info={documenti.contrattoPdf} />
        <DocumentoDownloadCard tipo="RICEVUTA_PDF" praticaId={id} info={documenti.ricevutaPdf} />
        <DocumentoDownloadCard tipo="RICEVUTA_XML" praticaId={id} info={documenti.ricevutaXml} />
        <DocumentoDownloadCard tipo="FATTURA_SDI" praticaId={id} info={documenti.fatturaSdi} />
      </div>
    </section>
  );
}
